import { ReceptorRecord } from '@trustero/trustero-api-web/lib/agent/receptor_pb'
import { SelectItem } from 'src/components/Reusable/SelectDropdown/SelectDropdown.constants'
import { FieldDef, MethodDef } from 'src/xgenerated/receptor'
import { ReceptorTemplate } from './ActivateReceptorForm'

export const getSelectedItems = (
  options: SelectItem[],
  selected: string,
): SelectItem[] => {
  const selectedArr = selected.split(',')
  return selectedArr.map((selected) => {
    const selectedOption = options.find((option) => option.value === selected)
    return {
      name: selectedOption ? selectedOption.name : '',
      value: selected,
    } as SelectItem
  })
}

const GRC_RECEPTOR_DEFAULT_TENANT_IDS: Record<string, string> = {
  'trr-archer': 'archer-tenant',
  'trr-anecdotes': 'anecdotes-tenant',
  'trr-metricstream': 'metricstream-tenant',
}

export const getDefaultTenantId = (
  receptor: ReceptorRecord.AsObject,
  hideTenantId: boolean,
): string => {
  if (receptor.tenantid) return receptor.tenantid
  if (hideTenantId) return `${receptor.modelid}-tenant`
  return GRC_RECEPTOR_DEFAULT_TENANT_IDS[receptor.modelid] ?? ''
}

export const getMethodDefaultActiveKey = (
  receptor: ReceptorRecord.AsObject,
  receptorTemplate: ReceptorTemplate,
  methodsOverride?: MethodDef[],
): number => {
  const methods = methodsOverride || receptorTemplate.methods || []
  if (methods.length === 0) return 0

  const creds = receptor.credentials ? JSON.parse(receptor.credentials) : {}

  let key = 0
  // if credentials are already set, set the active tab to the method that has credentials
  receptorTemplate.field_template?.forEach((field: FieldDef) => {
    if (field.method && creds[field.field.toLocaleLowerCase()]?.length > 0) {
      const currentIdx = methods.findIndex(
        (method) => method.value === field.method,
      )
      key = currentIdx > -1 ? currentIdx : 0
    }
  })
  return key
}

export const getOrderedMethods = (methods?: MethodDef[]): MethodDef[] => {
  if (!methods || methods.length <= 1) return methods || []

  return [...methods].sort((a, b) => {
    const rank = (value: string) => {
      if (value === 'service_account') return 0
      if (value === 'oauth') return 1
      return 2
    }

    return rank(a.value) - rank(b.value)
  })
}
